import { render, staticRenderFns } from "./CustomSelect.vue?vue&type=template&id=09a94b36&scoped=true"
import script from "./CustomSelect.vue?vue&type=script&lang=js"
export * from "./CustomSelect.vue?vue&type=script&lang=js"
import style0 from "./CustomSelect.vue?vue&type=style&index=0&id=09a94b36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a94b36",
  null
  
)

export default component.exports